// src/stores/unitsStore.js
import { writable, derived } from 'svelte/store';
const browser = typeof window !== 'undefined';
import { userSettings, updateSetting } from './userSettingsStore';

// Create a derived store that gets glucose unit from user settings
export const glucoseunit = derived(userSettings, ($userSettings) => {
  return $userSettings.glucoseUnit || 'mg/dL';
});

// Subscribe to changes and update DOM classes
if (browser) {
  glucoseunit.subscribe(value => {
    document.documentElement.classList.remove('mg/dL', 'mmol/L');
    document.documentElement.classList.add(value);
  });
}

export function toggleGlucoseUnit() {
  const currentUnit = get(glucoseunit);
  const newUnit = currentUnit === 'mg/dL' ? 'mmol/L' : 'mg/dL';
  
  // Update the user settings store
  updateSetting('glucoseUnit', newUnit);
}

// Helper function to get current value from store
function get(store) {
  let value;
  store.subscribe(v => value = v)();
  return value;
}